import http from "../http";
import qs from "qs";

const options = {
  url: "https://api.modusign.co.kr",
  headers: {
    accept: "application/json",
    "content-type": "application/json",
    authorization:
      "Basic dHJlZWQudGVzdDFAZ21haWwuY29tOlpUZGlZV00wWW1ZdE9EQm1OUzAwTXpSaUxUazNNR0V0Tmpaak9UQTBNMkZpTWpJMg==",
  },
};

// 템플릿 가져오는 api
async function getTemplates(payload) {
  try {
    // const payloadFilter = Object.fromEntries(
    //   Object.entries(payload).filter(([, value]) => value !== "")
    // );
    // keyword=?limit=?
    // const queryString = qs.stringify(payloadFilter);

    const res = await http(
      "GET",
      `${window.API_URL}/contract-templates?${qs.stringify(payload)}`
    );
    return res;
  } catch (error) {
    return error;
  }
}

// 템플릿 으로 서명 요청하는 api
async function templateDocuments() {
  try {
    const data = JSON.stringify({
      templateId: "d9c905f0-9969-11ee-8535-11855028d66e",
      document: {
        title: "2024_서명요청테스트_박경호10",
        participantMappings: [
          {
            role: "근로자",
            name: "박경호",
            signingMethod: {
              type: "EMAIL",
              value: "kh.park@alcherainc.com",
            },
            signingDuration: 20160,
            requesterMessage: "서명해 주세요.",
          },
        ],
      },
    });

    const res = await http(
      "POST",
      `${options.url}/documents/request-with-template`,
      data,
      options
    );
    return res;
  } catch (error) {
    return error;
  }
}

export default {
  getTemplates,
  templateDocuments,
};
